import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Contentful from '../../contentful';
import Text from '../../text/text';
import styles from './footer.scss';

class Footer extends Component {
  render() {
    return (
      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.actions}>
            <div className={styles.navigation}>
              <Contentful query={{ content_type: 'navigationZone', limit: 1, 'fields.title': 'Main' }}>
                {({ items }) => {
                  if (items.length === 0) { return null; }
                  const mainItems = items[0].fields.items;
                  return mainItems.map(item => (
                    <nav key={item.sys.id} className={styles.nav}>
                      <NavLink className={styles.navMainItem} to={'/' + item.fields.slug || ''} key={item.sys.id} onClick={this.toggleNavigation}>
                        {item.fields.title}
                      </NavLink>
                      {( item.fields.subPages && item.fields.subPages.map(item => (
                        <NavLink to={'/' + item.fields.slug || ''} key={item.sys.id} onClick={this.toggleNavigation}>
                          {item.fields.title}
                        </NavLink>
                      )))}
                    </nav>
                  ));
                }}
              </Contentful>
            </div>
            <div className={styles.contact}>
              <Contentful query={{ content_type: 'text', limit: 1, 'fields.title': 'Footer Kontakt' }}>
                {({ items, total }) => {
                  if (items.length === 0) { return null; }

                  return (
                    <Text text={items[0].fields.text}/>
                  )
                }}
              </Contentful>
            </div>
          </div>
          <div className={styles.meta}>
            <div className={styles.copyright}>
              &copy; Hannweber Engineering
            </div>
            <div className={styles.metaNavigation}>
              <Contentful query={{ content_type: 'navigationZone', limit: 1, 'fields.title': 'Footer Meta' }}>
                {({ items }) => {
                  if (items.length === 0) { return null; }
                  const metaItems = items[0].fields.items;
                  return metaItems.map(item => (
                    <NavLink to={'/' + item.fields.slug || ''} key={item.sys.id}>
                      {item.fields.title}
                    </NavLink>
                  ));
                }}
              </Contentful>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/footer/footer.jsx